import { useContext, useRef, useState } from "react";
import { Link } from 'react-router';
import { useLocation, Navigate, useNavigate } from "react-router";
import { UserContext } from "../contexts/user-context";
import apiPreferredCustomer from '../services/api-preferred-customer';
import SpinnerLoader from "../components/layout/spinner-loader";
import { bootstrap } from '../app';
import { useEffect } from "react";

const RequireAuth = ({ children, requireEmailVerification }) => {
    const { pcUser, activeRegion, loadingUser, errorLoadingPcProfile, getUserProfileSilently } = useContext(UserContext);
    const [emailVerificationRequired, setEmailVerificationRequired] = useState(null);
    const EmailVerificationRequiredModal = useRef();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (pcUser && !activeRegion) {
            navigate('/preferred-customer/switch-brand');
        }
        if (!pcUser) return;

        var verifNeeded = (requireEmailVerification ?? false) && !pcUser.emailVerified;
        setEmailVerificationRequired(verifNeeded);
        if (verifNeeded) {
            var modal = new bootstrap.Modal(EmailVerificationRequiredModal.current, {});
            modal.show();
        }
    }, [pcUser, activeRegion, requireEmailVerification]);

    const sendVerificationLink = () => {
        const sendEmail = async () => {
            await apiPreferredCustomer.get(`/request-email-verification`)
                .then(() => {
                    getUserProfileSilently();
                });;
        }
        sendEmail();
    }


    return (
        <>
            {loadingUser && <SpinnerLoader />}
        
            {!loadingUser && (!pcUser || errorLoadingPcProfile) && <Navigate to="/preferred-customer/account-required" state={{ from: location }} replace={true} />}
        
            <div className="modal fade" id="EmailVerificationRequiredModal" data-bs-backdrop="static" data-bs-keyboard="false" ref={EmailVerificationRequiredModal} tabIndex="-1" aria-labelledby="EmailVerificationRequiredModalLabel">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h2 className="modal-title" id="EmailVerificationRequiredModalLabel">Email Address Verification Required</h2>
                        </div>
                        <div className="modal-body">
                            {!loadingUser && pcUser && <>
                                <p className="no-localization">Hello {pcUser.firstName},</p>
                                <p>The email address we have on file for you is <strong>{pcUser.email}</strong>. If this is not correct, please <span data-bs-dismiss="modal"><Link to="/preferred-customer/profile">update your account information.</Link></span></p>
                                <p>For security purposes, we need to verify your email address. If you continue, you will be sent an email verification link and will need to re-login.</p>
                                <ul>
                                    <li><span data-bs-dismiss="modal"><button
                                        className="btn btn-link text-primary p-0"
                                        onClick={sendVerificationLink}>Send Verification Link</button></span></li>
                                    <li><span data-bs-dismiss="modal"><Link to="/tools">No thanks, I'll do this some other time.</Link></span></li>
                                </ul>
                            </>}
                        </div>
                    </div>
                </div>
            </div>

            {!loadingUser && pcUser && emailVerificationRequired !== null && emailVerificationRequired === false && children}

        </>
    )
};

export default RequireAuth